export const binaryFile1 = {
  type: 'object',
  instanceof: File.name,
};
